/**
 * World Marathon Majors percentile tables — GENERATED, do not edit by hand.
 *
 * Source: 2024 marathon results (runningwithrock/2024-marathon-results on Kaggle),
 *         596672 finishers across the Abbott World Marathon Majors and
 *         other large US races (NYC, Berlin, London, Chicago, Boston, LA, ...).
 *
 * Each value is the finish-time cutoff (seconds) at the given percentile for
 * that gender × age-group cohort, computed by linear interpolation over the
 * sorted finish times.
 *
 * IMPORTANT — distribution caveat: this field is FASTER and more trained than
 * the general recreational population. At the front it runs ~16 min quicker
 * than the RunRepeat all-runners median (P10) and it also has a longer slow
 * tail. These are raw empirical percentiles for the World-Majors entrant
 * population, NOT a normalized estimate of all marathoners. The UI surfaces
 * this distinction in its labels and footnotes.
 *
 * Regenerate with: node scripts/precompute-majors.mjs
 */

export const MAJORS_GRID = [
  0.1, 0.5, 1, 2, 3, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 95, 97, 98, 99, 99.5, 99.9
] as const;
export const MAJORS_AGE_GROUPS = ["Under 20","20-24","25-29","30-34","35-39","40-44","45-49","50-54","55-59","60-64","65-69","70-74","75-79","80 and Over"] as const;
export const MAJORS_TABLE: Record<string, Partial<Record<string, Record<string, number>>>> = {
  "Men": {
    "Under 20": {
      "1": 9116,
      "2": 9419,
      "3": 9660,
      "5": 10064,
      "10": 10765,
      "20": 12249,
      "30": 13188,
      "40": 14020,
      "50": 14817,
      "60": 15807,
      "70": 16951,
      "80": 18391,
      "90": 20709,
      "95": 22951,
      "97": 24258,
      "98": 25256,
      "99": 26898,
      "0.1": 8548,
      "0.5": 8899,
      "99.5": 28531,
      "99.9": 32693
    },
    "20-24": {
      "1": 9327,
      "2": 9724,
      "3": 9999,
      "5": 10414,
      "10": 11256,
      "20": 12485,
      "30": 13390,
      "40": 14075,
      "50": 14819,
      "60": 15742,
      "70": 16773,
      "80": 17965,
      "90": 19890,
      "95": 21469,
      "97": 22708,
      "98": 23682,
      "99": 25569,
      "0.1": 8565,
      "0.5": 8986,
      "99.5": 27578,
      "99.9": 32757
    },
    "25-29": {
      "1": 9177,
      "2": 9581,
      "3": 9880,
      "5": 10240,
      "10": 10857,
      "20": 12209,
      "30": 13123,
      "40": 13905,
      "50": 14575,
      "60": 15560,
      "70": 16545,
      "80": 17746,
      "90": 19658,
      "95": 21292,
      "97": 22478,
      "98": 23405,
      "99": 24984,
      "0.1": 7954,
      "0.5": 8841,
      "99.5": 26823,
      "99.9": 33110
    },
    "30-34": {
      "1": 9161,
      "2": 9552,
      "3": 9844,
      "5": 10204,
      "10": 10758,
      "20": 11979,
      "30": 12915,
      "40": 13766,
      "50": 14444,
      "60": 15469,
      "70": 16528,
      "80": 17791,
      "90": 19821,
      "95": 21554,
      "97": 22858,
      "98": 23797,
      "99": 25489,
      "0.1": 8028,
      "0.5": 8821,
      "99.5": 27733,
      "99.9": 33441
    },
    "35-39": {
      "1": 9389,
      "2": 9730,
      "3": 9981,
      "5": 10344,
      "10": 10815,
      "20": 11903,
      "30": 12796,
      "40": 13655,
      "50": 14357,
      "60": 15341,
      "70": 16396,
      "80": 17712,
      "90": 19774,
      "95": 21443,
      "97": 22742,
      "98": 23691,
      "99": 25436,
      "0.1": 8430,
      "0.5": 9084,
      "99.5": 27389,
      "99.9": 33550
    },
    "40-44": {
      "1": 9553,
      "2": 9871,
      "3": 10117,
      "5": 10495,
      "10": 10998,
      "20": 11968,
      "30": 12835,
      "40": 13677,
      "50": 14378,
      "60": 15384,
      "70": 16461,
      "80": 17779,
      "90": 19912,
      "95": 21661,
      "97": 23051,
      "98": 24066,
      "99": 25800,
      "0.1": 8844,
      "0.5": 9296,
      "99.5": 27734,
      "99.9": 33354
    },
    "45-49": {
      "1": 9864,
      "2": 10176,
      "3": 10406,
      "5": 10709,
      "10": 11339,
      "20": 12206,
      "30": 13072,
      "40": 13851,
      "50": 14628,
      "60": 15653,
      "70": 16784,
      "80": 18087,
      "90": 20216,
      "95": 21935,
      "97": 23247,
      "98": 24361,
      "99": 25956,
      "0.1": 9147,
      "0.5": 9614,
      "99.5": 28022,
      "99.9": 34489
    },
    "50-54": {
      "1": 10269,
      "2": 10586,
      "3": 10764,
      "5": 11148,
      "10": 11769,
      "20": 12645,
      "30": 13522,
      "40": 14256,
      "50": 15162,
      "60": 16122,
      "70": 17230,
      "80": 18604,
      "90": 20632,
      "95": 22458,
      "97": 23806,
      "98": 24835,
      "99": 26631,
      "0.1": 9471,
      "0.5": 10012,
      "99.5": 29134,
      "99.9": 36319
    },
    "55-59": {
      "1": 10678,
      "2": 11029,
      "3": 11313,
      "5": 11747,
      "10": 12367,
      "20": 13230,
      "30": 14027,
      "40": 14844,
      "50": 15791,
      "60": 16759,
      "70": 17833,
      "80": 19294,
      "90": 21420,
      "95": 23317,
      "97": 24741,
      "98": 25758,
      "99": 27835,
      "0.1": 9878,
      "0.5": 10425,
      "99.5": 30582,
      "99.9": 36169
    },
    "60-64": {
      "1": 11217,
      "2": 11669,
      "3": 11956,
      "5": 12341,
      "10": 12972,
      "20": 13802,
      "30": 14616,
      "40": 15552,
      "50": 16550,
      "60": 17557,
      "70": 18779,
      "80": 20261,
      "90": 22276,
      "95": 24300,
      "97": 25920,
      "98": 27476,
      "99": 30198,
      "0.1": 10347,
      "0.5": 10795,
      "99.5": 32953,
      "99.9": 39029
    },
    "65-69": {
      "1": 11980,
      "2": 12399,
      "3": 12633,
      "5": 13068,
      "10": 13742,
      "20": 14733,
      "30": 15735,
      "40": 16717,
      "50": 17620,
      "60": 18680,
      "70": 19888,
      "80": 21407,
      "90": 23798,
      "95": 26326,
      "97": 28112,
      "98": 29844,
      "99": 32722,
      "0.1": 10875,
      "0.5": 11631,
      "99.5": 34363,
      "99.9": 39931
    },
    "70-74": {
      "1": 13010,
      "2": 13418,
      "3": 13703,
      "5": 14108,
      "10": 14922,
      "20": 16079,
      "30": 17135,
      "40": 18067,
      "50": 19207,
      "60": 20319,
      "70": 21500,
      "80": 23025,
      "90": 25669,
      "95": 29250,
      "97": 31199,
      "98": 32340,
      "99": 35472,
      "0.1": 12095,
      "0.5": 12579,
      "99.5": 38631,
      "99.9": 46400
    },
    "75-79": {
      "1": 13483,
      "2": 14476,
      "3": 14886,
      "5": 15559,
      "10": 16480,
      "20": 17705,
      "30": 18979,
      "40": 20245,
      "50": 21240,
      "60": 22229,
      "70": 23398,
      "80": 24972,
      "90": 27851,
      "95": 30610,
      "97": 32056,
      "98": 33404,
      "99": 36290,
      "0.1": 12365,
      "0.5": 13213,
      "99.5": 40026,
      "99.9": 47146
    }
  },
  "Women": {
    "Under 20": {
      "1": 10713,
      "2": 11148,
      "3": 11422,
      "5": 11907,
      "10": 12688,
      "20": 14016,
      "30": 15040,
      "40": 16035,
      "50": 17016,
      "60": 18091,
      "70": 19452,
      "80": 21051,
      "90": 23440,
      "95": 25154,
      "97": 26261,
      "98": 27243,
      "99": 28511,
      "0.1": 10006,
      "0.5": 10460,
      "99.5": 30176,
      "99.9": 37024
    },
    "20-24": {
      "1": 10957,
      "2": 11382,
      "3": 11658,
      "5": 12012,
      "10": 12731,
      "20": 13832,
      "30": 14546,
      "40": 15377,
      "50": 16078,
      "60": 16904,
      "70": 17814,
      "80": 19043,
      "90": 20924,
      "95": 22731,
      "97": 24001,
      "98": 24986,
      "99": 26864,
      "0.1": 9704,
      "0.5": 10565,
      "99.5": 29279,
      "99.9": 33245
    },
    "25-29": {
      "1": 10581,
      "2": 11101,
      "3": 11429,
      "5": 11838,
      "10": 12482,
      "20": 13620,
      "30": 14379,
      "40": 15282,
      "50": 16107,
      "60": 16962,
      "70": 17878,
      "80": 19205,
      "90": 21142,
      "95": 22906,
      "97": 24202,
      "98": 25141,
      "99": 26827,
      "0.1": 9321,
      "0.5": 10167,
      "99.5": 29107,
      "99.9": 34153
    },
    "30-34": {
      "1": 10489,
      "2": 10882,
      "3": 11249,
      "5": 11726,
      "10": 12388,
      "20": 13545,
      "30": 14389,
      "40": 15353,
      "50": 16207,
      "60": 17148,
      "70": 18209,
      "80": 19672,
      "90": 21660,
      "95": 23710,
      "97": 24974,
      "98": 25886,
      "99": 27648,
      "0.1": 8915,
      "0.5": 10024,
      "99.5": 30155,
      "99.9": 36122
    },
    "35-39": {
      "1": 10641,
      "2": 11110,
      "3": 11446,
      "5": 11874,
      "10": 12488,
      "20": 13501,
      "30": 14364,
      "40": 15392,
      "50": 16289,
      "60": 17280,
      "70": 18436,
      "80": 19901,
      "90": 21948,
      "95": 23949,
      "97": 25206,
      "98": 26060,
      "99": 27623,
      "0.1": 9434,
      "0.5": 10276,
      "99.5": 30170,
      "99.9": 35382
    },
    "40-44": {
      "1": 10921,
      "2": 11382,
      "3": 11691,
      "5": 12116,
      "10": 12744,
      "20": 13676,
      "30": 14532,
      "40": 15525,
      "50": 16436,
      "60": 17427,
      "70": 18575,
      "80": 20020,
      "90": 22089,
      "95": 24012,
      "97": 25312,
      "98": 26236,
      "99": 28102,
      "0.1": 9768,
      "0.5": 10592,
      "99.5": 30401,
      "99.9": 37662
    },
    "45-49": {
      "1": 11285,
      "2": 11730,
      "3": 12018,
      "5": 12416,
      "10": 13039,
      "20": 13873,
      "30": 14754,
      "40": 15702,
      "50": 16665,
      "60": 17641,
      "70": 18809,
      "80": 20325,
      "90": 22489,
      "95": 24434,
      "97": 25748,
      "98": 26742,
      "99": 28702,
      "0.1": 10315,
      "0.5": 10957,
      "99.5": 31332,
      "99.9": 38685
    },
    "50-54": {
      "1": 11814,
      "2": 12301,
      "3": 12553,
      "5": 12955,
      "10": 13553,
      "20": 14409,
      "30": 15402,
      "40": 16353,
      "50": 17307,
      "60": 18319,
      "70": 19533,
      "80": 20974,
      "90": 23162,
      "95": 25127,
      "97": 26455,
      "98": 27679,
      "99": 30738,
      "0.1": 10752,
      "0.5": 11487,
      "99.5": 33906,
      "99.9": 40451
    },
    "55-59": {
      "1": 12277,
      "2": 12724,
      "3": 13028,
      "5": 13392,
      "10": 14017,
      "20": 14944,
      "30": 15875,
      "40": 16781,
      "50": 17700,
      "60": 18751,
      "70": 19990,
      "80": 21324,
      "90": 23644,
      "95": 25673,
      "97": 27446,
      "98": 29082,
      "99": 32020,
      "0.1": 11007,
      "0.5": 11874,
      "99.5": 34514,
      "99.9": 41286
    },
    "60-64": {
      "1": 12827,
      "2": 13290,
      "3": 13513,
      "5": 13937,
      "10": 14596,
      "20": 15585,
      "30": 16536,
      "40": 17363,
      "50": 18353,
      "60": 19536,
      "70": 20713,
      "80": 22182,
      "90": 24804,
      "95": 27357,
      "97": 29689,
      "98": 31096,
      "99": 33184,
      "0.1": 11607,
      "0.5": 12314,
      "99.5": 35307,
      "99.9": 42549
    },
    "65-69": {
      "1": 13223,
      "2": 13834,
      "3": 14058,
      "5": 14583,
      "10": 15558,
      "20": 16550,
      "30": 17480,
      "40": 18356,
      "50": 19376,
      "60": 20470,
      "70": 21587,
      "80": 23237,
      "90": 26115,
      "95": 29433,
      "97": 31563,
      "98": 33608,
      "99": 35656,
      "0.1": 12179,
      "0.5": 12860,
      "99.5": 38676,
      "99.9": 48258
    },
    "70-74": {
      "1": 13707,
      "2": 14305,
      "3": 14805,
      "5": 15442,
      "10": 16494,
      "20": 17782,
      "30": 18607,
      "40": 19713,
      "50": 20749,
      "60": 21854,
      "70": 23248,
      "80": 24717,
      "90": 28007,
      "95": 31508,
      "97": 33504,
      "98": 34371,
      "99": 36254,
      "0.1": 13203,
      "0.5": 13571,
      "99.5": 39226,
      "99.9": 44187
    }
  }
};
export const MAJORS_COHORT_SIZES: Record<string, Partial<Record<string, number>>> = {
  "Men": {
    "Under 20": 21591,
    "20-24": 25873,
    "25-29": 52571,
    "30-34": 52476,
    "35-39": 47097,
    "40-44": 46897,
    "45-49": 37511,
    "50-54": 32228,
    "55-59": 22126,
    "60-64": 14666,
    "65-69": 6784,
    "70-74": 2800,
    "75-79": 823
  },
  "Women": {
    "Under 20": 15273,
    "20-24": 18322,
    "25-29": 39417,
    "30-34": 32542,
    "35-39": 28261,
    "40-44": 31813,
    "45-49": 25249,
    "50-54": 19546,
    "55-59": 12177,
    "60-64": 7041,
    "65-69": 2720,
    "70-74": 868
  }
};
